import { AfterContentInit, ContentChildren, Directive, forwardRef, QueryList } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../../classes/base-control-value-accessor';
import { RadioGroupChildDirective } from './radio-group-child.directive';

@Directive({
  selector: '[dsdExtRadioGroupValueAccessor], dsd-radio-group',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioGroupValueAccessorDirective)
    }
  ],
  standalone: false
})
export class RadioGroupValueAccessorDirective extends BaseControlValueAccessor implements AfterContentInit {
  @ContentChildren(RadioGroupChildDirective)
  radioButtons: QueryList<RadioGroupChildDirective>;

  ngAfterContentInit(): void {
    this.writeValue(this.value);
    this.listenToValueChange();
  }

  private listenToValueChange() {
    for (const radio of this.radioButtons) {
      radio.onValueChange = value => this.updateFormValue(value);
    }
  }

  updateFormValue(value): void {
    this.onChange(value);
  }

  writeValue(value?: string | number): void {
    this.value = value;

    if (this.radioButtons) {
      for (const radio of this.radioButtons) {
        radio.checked = radio.value === value;
      }
    }
  }
}
